import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-checkbox',
  templateUrl: './primeng-checkbox.component.html',
  styleUrls: ['./primeng-checkbox.component.scss'],
  standalone: false,
})
export class PrimengCheckboxComponent {
  value = model<boolean>(false);
  inputId = input<string>('');
  disabled = input<boolean>(false);
  readonly = input<boolean>(false);
  indeterminate = input<boolean>(false);

  onChange = output<any>();

  handleChange(event: any) {
    this.onChange.emit(event);
  }
}
